export const sendParentEvent = (payload) => {
  window.parent.postMessage(payload, '*')
}
